import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ProjectEditOffTheShelfOfferPage } from '@/areas/offers/StandardPartOfferForm/pages/ProjectEditOffTheShelfOfferPage';
import { sourcingEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/projects/$projectId/sourcing/offers/off-the-shelf/$offerId/edit',
)({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingEditModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <ProjectEditOffTheShelfOfferPage projectId={pathParams.projectId} offerId={pathParams.offerId} />;
}
